module.exports = ".logo {\n  float: left;\n  height: 24px;\n  margin-top: 7px;\n  margin-right: 15px;\n}\n.nav.navbar-padding {\n  margin-left: 25px;\n  margin-top: 10px;\n}\n.app-title {\n  float: left;\n  font-size: 20px;\n  margin-top: 8px;\n}\n.header-nav {\n  text-align: right;\n  margin-top: 7px;\n  font-size: 16px;\n  font-weight: normal;\n}\n.header-nav .user-name {\n  float: right;\n}\n.header-nav .logout {\n  float: right;\n  font-weight: bold !important;\n  padding-bottom: 5px;\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = 506
// module chunks = 0